// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable babel/camelcase, func-names */
import Price from "@kiwicom/frontend-common/records/Price"
import { BAGS_TYPES } from "@kiwicom/frontend-common/types/bags"

import type { Baggage } from "../../../../../../../common/types/baggageTypes"
import type { BaggagesInput, BlueRibbonBagInput } from "../../../../../../../records/bookingInput"

export const getPassengerIdsWithBlueRibbonBags = (
  input?: BlueRibbonBagInput[] | null,
): string[] => {
  if (!input) return []

  // Fix this the next time the file is edited. (Flow to TS)
  // @ts-expect-error: Flow to TS migration.
  // eslint-disable-next-line @typescript-eslint/array-type, no-undef
  let passengerIds: Array<PassengerId> | Array<string> = []

  input.forEach(({ items }) =>
    items.forEach(({ passenger_id }) => {
      passengerIds = [...passengerIds, passenger_id]
    }),
  )

  return passengerIds
}

export default function (
  baggages: BaggagesInput,
  blueRibbonBags?: BlueRibbonBagInput[] | null,
): Baggage[] {
  const passengerIdsWithBlueRibbonBags = getPassengerIdsWithBlueRibbonBags(blueRibbonBags)

  return (
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, @typescript-eslint/prefer-optional-chain
    baggages &&
    baggages.confirmed.map((bagPerFlight) => ({
      additionalBookingId: bagPerFlight.additional_booking_id,
      bid: bagPerFlight.booking_id,
      id: bagPerFlight.bag.id,
      flightFid: bagPerFlight.flight_fid,
      flightId: String(bagPerFlight.flight_id),
      index: bagPerFlight.index,
      pid: bagPerFlight.passenger_id,
      price: new Price({
        amount: bagPerFlight.price.amount,
        currency: bagPerFlight.price.currency,
      }),
      category: bagPerFlight.bag.category,
      isHold: bagPerFlight.is_hold,
      isBlueRibbon:
        // @ts-expect-error: Flow to TS migration.
        passengerIdsWithBlueRibbonBags.includes(bagPerFlight.passenger_id) &&
        bagPerFlight.bag.category === BAGS_TYPES.HOLD_BAG,
      bag: {
        category: bagPerFlight.bag.category,
        height: bagPerFlight.bag.height,
        length: bagPerFlight.bag.length,
        weight: bagPerFlight.bag.weight,
        width: bagPerFlight.bag.width,
      },
    }))
  )
}
